import { MicrodataScheme } from '@keaze/web/common/interfaces';

export const FAQScheme: MicrodataScheme = {
  wrapper: {
    itemScope: true,
    itemType: 'https://schema.org/FAQPage',
  },
  entity: {
    itemScope: true,
    itemProp: 'mainEntity',
    itemType: 'https://schema.org/Question',
  },
  entityTitle: {
    itemProp: 'name',
  },
  description: {
    itemScope: true,
    itemProp: 'acceptedAnswer',
    itemType: 'https://schema.org/Answer',
  },
  descriptionValue: {
    itemProp: 'text',
  },
};
